module.exports = __webpack_public_path__ + "assets/img/xlwj.393867ca.svg";